import type { DocumentListVariant, DocumentRowStatus } from "@/types/DocumentTypes";

export const DOCUMENT_PROCESSING_TIMEOUT_MS = 15_000;

export const GROUP_STATUS_PRECEDENCE: DocumentRowStatus[] = [
  "action_needed",
  "uploading",
  "detecting_type",
  "complete",
];

export const DOCUMENT_GRID_CLASSES: Record<DocumentListVariant, string> = {
  compact: "grid-cols-[minmax(0,1fr)_10rem_10rem_minmax(0,1fr)]",
  full: "grid-cols-[minmax(0,1fr)_10rem_10rem_minmax(0,1fr)] lg:grid-cols-[minmax(0,1fr)_14rem_10rem_10rem_minmax(0,1fr)] xl:grid-cols-[minmax(0,1fr)_22rem_10rem_10rem_minmax(0,1fr)]",
};
